module.exports = __webpack_public_path__ + "static/media/generic.d794568f.svg";